<script lang="ts">
	import { BaseHeading, type BaseHeadingProps } from '../BaseHeading';

	interface Props {
		token: BaseHeadingProps['token'];
	}

	let { token }: Props = $props();
	export const options: BaseHeadingProps['options'] = undefined;
	export const renderers: BaseHeadingProps['renderers'] = undefined;
</script>

<BaseHeading {token} {options} {renderers} class="text-gray-500" />
